export default "__VITE_ASSET__uCB2axd6__"